import React, { useEffect, useState } from "react";
import { CustomToast } from "../alert/custom-toast";
import { CustomLoader } from "../custom-loader/custom-loader";
import { Optional } from "../optional/optional";

export function DownloadConfirmation(props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (props.loading) {
      setError(null);
    } else if (props.error) {
      setError(props.error);
    }
    setLoading(props.loading);
  }, [props.error, props.loading]);

  return (
    <div>
      <div className="p-pb-1"></div>
      <h4 className="p-text-left p-mt-0">Confirm Download!</h4>
      <p className="p-text-left">
        Confirm that you want to download this item.
      </p>
      {/* <Optional show={loading}>
        <DownloadProgress />
      </Optional> */}
      {error && <CustomToast title="Error" description={error} type="error" />}
      {loading ? <CustomLoader loadingText="Loading..." /> : null}
      <Optional show={!loading}>
        <div className="p-mt-4 p-pb-2">
          <div className="p-grid">
            <div className="p-col-6">
              <button onClick={props.closeModal} className="secondary-button">
                Cancel
              </button>
            </div>
            <div className="p-col-6">
              <button onClick={props.onDownload} className="primary-button">
                Download
              </button>
            </div>
          </div>
        </div>
      </Optional>
      {/* )} */}
    </div>
  );
}
